import React from 'react';
import { Box, Stack, Inline } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { boxStyles } from '../../constants/styles';

interface Props {
  testId?: string;
  cardsCount?: number;
}

const renderBoxContent = () => {
  const marginBottom = '0';

  return (
    <Box padding="space.200" xcss={boxStyles}>
      <SkeletonLoaderWrapper>
        <Inline grow="fill" alignBlock="center">
          <SkeletonLoader height="30px" width="80px" marginRight="1rem" marginBottom={marginBottom} />
          <SkeletonLoader width="50%" marginBottom={marginBottom} />
          <div
            style={{
              width: '100%',
              float: 'right',
            }}
          >
            <SkeletonLoader width="4%" isRightAligned marginBottom={marginBottom} />
            <SkeletonLoader width="15%" isRightAligned marginBottom={marginBottom} />
            <SkeletonLoader width="15%" isRightAligned marginBottom={marginBottom} />
          </div>
        </Inline>
      </SkeletonLoaderWrapper>
    </Box>
  );
};

/**
 * PaymentMethodsLoader component is used to render payment methods tab content in details (billing account) page.
 * @param testId - testId for the component
 * @param cardsCount - number of cards to render
 */
export const PaymentMethodsLoader = ({ testId = 'payment-methods-loader', cardsCount = 3 }: Props) => {
  const renderContentLoaders = () => {
    return <Stack grow="fill">{Array.from({ length: cardsCount }).map((_) => renderBoxContent())}</Stack>;
  };

  return (
    <div data-testid={testId}>
      <SkeletonLoaderWrapper>
        <SkeletonLoader width="10%" isRightAligned />
      </SkeletonLoaderWrapper>
      {renderContentLoaders()}
    </div>
  );
};
